import React from "react";
import {Button, CloseIcon, Dialog, Flex, Text} from "@fluentui/react-northstar";

interface IGenericDialogProps {
    show: boolean,
    width?: number,
    height?: number,
    onHide: () => void,
    children: JSX.Element,
    title?: string,
}

export const GenericDialog = (props: IGenericDialogProps) => {
    return (
        <Dialog
            open={props.show}
            styles={{
                paddingBottom: "0",
                display: "flex",
                width: (props.width ?? 600) + "px",
                height: (props.height ?? 600) + "px",
                overflow: "hidden !important"
            }}
            content={{
                styles: {marginBottom: "0"},
                content: (
                    <Flex fill column gap={"gap.medium"}>
                        <Flex styles={{width: "100%"}} space={"between"} gap={"gap.small"} vAlign={"center"}>
                            <Text truncated styles={{maxWidth: "calc(100% - 50px)"}} content={props.title}
                                  size={"large"} weight={"bold"}/>
                            <Button text icon={<CloseIcon outline/>} iconOnly onClick={props.onHide}/>
                        </Flex>
                        <Flex fill styles={{overflowX: "hidden", overflowY: "scroll"}}>
                            {props.children}
                        </Flex>
                    </Flex>
                )
            }}
        />
    )
}